import React, { useEffect } from 'react'
import TabsContainer from '../tab/Tabs'

const MetricAnalyticWithTabs = ({
  metricsType,
  setMetricsType,
  getCurrentMetricsData,
  metricsDetail,
  catchedError,
  TABTITLES,
}) => {
  useEffect(() => {
    getCurrentMetricsData(metricsType)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metricsType])

  return (
    <TabsContainer
      tabTitles={TABTITLES}
      setType={setMetricsType}
      tabType={metricsType}
      tabDetail={metricsDetail}
      catchedError={catchedError}
    />
  )
}

export default MetricAnalyticWithTabs
